import { render } from "./ConfirmacionRegistroGas.vue?vue&type=template&id=059c4259&scoped=true"
import script from "./ConfirmacionRegistroGas.vue?vue&type=script&lang=js"
export * from "./ConfirmacionRegistroGas.vue?vue&type=script&lang=js"

import "./ConfirmacionRegistroGas.vue?vue&type=style&index=0&id=059c4259&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059c4259"]])

export default __exports__